export class FiltroRicercaClassificaDTO {
  codice: string;
  cmu: string;
  exactMatch: boolean;
  showCancellati: boolean;
  soloCancellati: boolean;
  countChildren: boolean;
  dataInferiore: string;
  dataSuperiore: string;
}
